import { render } from "./TicketManage.vue?vue&type=template&id=2f01faa8&scoped=true"
import script from "./TicketManage.vue?vue&type=script&lang=js"
export * from "./TicketManage.vue?vue&type=script&lang=js"

import "./TicketManage.vue?vue&type=style&index=0&id=2f01faa8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f01faa8"]])

export default __exports__